const REACT_HOOK_COUNT_ERROR =
  /Rendered (?:more|fewer) hooks than|Minified React error #3(?:0|1)0\b|react\.dev\/errors\/3(?:0|1)0\b/;

export function isReactHookCountError(error: unknown): boolean {
  return error instanceof Error && REACT_HOOK_COUNT_ERROR.test(error.message);
}

const REACT_UPDATE_DEPTH_ERROR =
  /Maximum update depth exceeded|Minified React error #185\b|react\.dev\/errors\/185\b/;

export function isReactUpdateDepthError(error: unknown): boolean {
  return error instanceof Error && REACT_UPDATE_DEPTH_ERROR.test(error.message);
}

export function isAutoRecoverableRouteError(error: unknown): boolean {
  return isReactHookCountError(error) || isReactUpdateDepthError(error);
}

export const ROUTE_RECOVER_MAX_ATTEMPTS = 3;
export const ROUTE_RECOVER_BURST_MS = 30_000;

export interface RouteRecoverState {
  attempts: number;
  lastAttemptTs: number;
}

export const INITIAL_ROUTE_RECOVER_STATE: RouteRecoverState = {
  attempts: 0,
  lastAttemptTs: 0,
};

export function planRouteRecovery(
  error: unknown,
  state: RouteRecoverState,
  now: number,
  maxAttempts: number = ROUTE_RECOVER_MAX_ATTEMPTS,
  burstMs: number = ROUTE_RECOVER_BURST_MS,
): { recover: boolean; nextState: RouteRecoverState } {
  if (!isAutoRecoverableRouteError(error)) {
    return { recover: false, nextState: state };
  }
  const isNewBurst = state.lastAttemptTs === 0 || now - state.lastAttemptTs > burstMs;
  const attemptsSoFar = isNewBurst ? 0 : state.attempts;
  if (attemptsSoFar >= maxAttempts) {
    return { recover: false, nextState: { attempts: attemptsSoFar, lastAttemptTs: now } };
  }
  return {
    recover: true,
    nextState: { attempts: attemptsSoFar + 1, lastAttemptTs: now },
  };
}
